import { useEffect } from 'react';
import './App.scss';
import NavHeader from './components/Header/NavHeader';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRoute from './routes/AppRoute';
import { Watch } from 'react-loader-spinner';
import { useDispatch, useSelector } from 'react-redux';
import Footer from './components/Footer/Footer';
import { fetchUserAccount } from './redux/slice/userSlice';

function App() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(fetchUserAccount());
  }, [dispatch]);

  return (
    <BrowserRouter>
      {user?.isLoading ? (
        <div className="loading-container d-flex justify-content-center">
          <Watch visible height="80" width="80" radius="48" color="#000" ariaLabel="watch-loading" />
          <div>Đang tải...</div>
        </div>
      ) : (
        <>
          <div className="app-header"><NavHeader /></div>
          <div className="app-container"><AppRoute /></div>
          <Footer />
        </>
      )}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </BrowserRouter>
  );
}

export default App;
